import { useSetupStore } from '../../store/setupStore';

const FeedbackTypeStep = () => {
  const { setup, updateSetup } = useSetupStore();

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">Feedback Type</h2>
      <p className="text-gray-600">
        Choose when during the class you want to collect feedback and how many
        questions to ask.
      </p>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            When to collect feedback?
          </label>
          <div className="grid grid-cols-3 gap-4">
            <button
              type="button"
              onClick={() => updateSetup({ feedbackType: 'entrance' })}
              className={`p-4 border rounded-lg text-center transition-all duration-200 ${
                setup.feedbackType === 'entrance'
                  ? 'border-emerald-500 bg-emerald-50 shadow-md'
                  : 'border-gray-200 hover:border-emerald-500 hover:shadow-md bg-white'
              }`}
            >
              <h3 className="font-medium">Entrance Ticket</h3>
              <p className="text-sm text-gray-500 mt-1">
                Collect feedback at the start of class
              </p>
            </button>
            <button
              type="button"
              onClick={() => updateSetup({ feedbackType: 'middle' })}
              className={`p-4 border rounded-lg text-center transition-all duration-200 ${
                setup.feedbackType === 'middle'
                  ? 'border-emerald-500 bg-emerald-50 shadow-md'
                  : 'border-gray-200 hover:border-emerald-500 hover:shadow-md bg-white'
              }`}
            >
              <h3 className="font-medium">Break Feedback</h3>
              <p className="text-sm text-gray-500 mt-1">
                Collect feedback during class break
              </p>
            </button>
            <button
              type="button"
              onClick={() => updateSetup({ feedbackType: 'exit' })}
              className={`p-4 border rounded-lg text-center transition-all duration-200 ${
                setup.feedbackType === 'exit'
                  ? 'border-emerald-500 bg-emerald-50 shadow-md'
                  : 'border-gray-200 hover:border-emerald-500 hover:shadow-md bg-white'
              }`}
            >
              <h3 className="font-medium">Exit Ticket</h3>
              <p className="text-sm text-gray-500 mt-1">
                Collect feedback at the end of class
              </p>
            </button>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Questions per session
          </label>
          <input
            type="number"
            min="1"
            max="5"
            value={setup.questionsPerSession}
            onChange={(e) =>
              updateSetup({ questionsPerSession: parseInt(e.target.value) })
            }
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
            aria-label="Questions per session"
          />
          <p className="mt-1 text-sm text-gray-500">
            Recommended: 2-3 questions for better response rates
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeedbackTypeStep;